// src/components/organization/OrganizationLoader.tsx

import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchOrganizations } from "@/api/organizations";
import { queryKeys } from "@/lib/query-keys";
import { useAuthStore } from "@/store/auth";
import { useOrganizationStore } from "@/store/organization";

export const OrganizationsLoader = () => {
  const setOrganizationState = useOrganizationStore(
    (s) => s.setOrganizationState,
  );
  const hasExternalAuth = useAuthStore((s) => s.hasExternalAuth);
  const externalOrganizationId = useOrganizationStore(
    (s) => s.externalOrganizationId,
  );
  const isSwitching = useOrganizationStore((s) => s.isSwitching);

  const {
    data: organizations = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: queryKeys.organizations.all(),
    queryFn: fetchOrganizations,
    enabled: hasExternalAuth,
  });

  useEffect(() => {
    setOrganizationState({
      organizations,
      isLoading,
      error,
    });
  }, [error, setOrganizationState, organizations, isLoading]);

  useEffect(() => {
    if (organizations.length === 0 || isSwitching) {
      return;
    }

    let organization = organizations[0];

    if (externalOrganizationId) {
      organization =
        organizations.find((o) => o.external_id === externalOrganizationId) ??
        organizations[0];
    }

    setOrganizationState({
      organization,
    });
  }, [
    externalOrganizationId,
    isSwitching,
    organizations,
    setOrganizationState,
  ]);

  return null;
};
